module.exports = __webpack_public_path__ + "media/assets/default-logo-0f0f1cc99dce2adb7c5b276e488defb50b15723fc8982bfa449e163c15ca5ea1.png";